// NATIVE 
import { useCallback, useEffect, useRef, useState } from 'react';

// INSTALLED 
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, Card, Divider, Grid, IconButton, Snackbar, Tooltip, Typography } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { SnackbarProvider, VariantType, useSnackbar } from 'notistack';


// CUSTOM 
import InputField from '../../../formFields/InputField';
import InputNumeric from '../../../formFields/InputNumeric';
import CheckboxField from '../../../formFields/checkBoxField';
import AutocompleteField from '../../../formFields/autocompleteField';
import { IDatosBasicos } from '../../../../commons/interfaces';
import DatePickerField from '../../../formFields/datePickerField';
import { UploadButtonField } from '../../../formFields/uploadButtonField';
import { uploadPdfStore } from '../../../../store/uploaders';
import { SnackAlert } from '../../../SnackAlert';
import { SnackGroupAlerts } from '../../../SnackGroupAlerts';
import { storeSizeFamily } from '../../../../store/size_family';
import { LinearProgressWithLabel } from '../../../LinearProgressWithLabel';

export const DinamicFamilia = ({ children }: any) => {


    const dispatch = useDispatch();

    const formikProps:any = useFormikContext();


    const { sizefamily }:any = useSelector( (state:any) => state.sizefamily );

    const  { type_documents_list } = useSelector( (state:any) => state.tipodocumento );



    const [percentage_upload_cc, setPercentageUploadCc]   = useState(0);



    const [inputs, setInputs] = useState([]);


    // const { formField: {
    //   // DATOS CLIENTE 
    //   family

    //   }
    // } = props;



    useEffect(() => {

        // let sizeFamily:any = [];

        // for (let index = 1; index <= children; index++) {
        //     sizeFamily.push(index);
        // }

        // setInputs(sizeFamily);

        if (children > 0) {
            dispatch( storeSizeFamily(children) );
        }
        

    }, [children]);



    

    const parentesco_list =  [
      { label: 'Cónyuge', value: 'Cónyuge'},
      { label: 'Hijo', value: 'Hijo'},
      { label: 'Hijastro', value: 'Hijastro'},
      { label: 'Padre', value: 'Padre'},
      { label: 'Madre', value: 'Madre'},
    ];


    const genderList =  [
      { label: 'Masculino', value: 'masculino'},
      { label: 'Femenino', value: 'Femenino'},
      { label: 'Otro', value: 'otro'}
    ];


    const escolaridadList =  [
      { label: 'primaria', value: 'primaria'},
      { label: 'bachillerato', value: 'bachillerato'},
      { label: 'tecnico', value: 'tecnico'},
      { label: 'tecnologo', value: 'tecnologo'},
      { label: 'postgrado', value: 'postgrado'},
    ];



    const uploadDocument = async({ target }:any) => {
      formikProps.setFieldValue('family', 'ssss' );
      // formikProps.setFieldValue('docidentidad', target.files[0]);
      const { ok, data } = await dispatch( uploadPdfStore( 'doc-beneficiario-empleado', target.files[0], setPercentageUploadCc) );
      
      if (ok) {
        
          
      }
    
    }
    

    // formikProps.setFieldValue('family', 'ssss' );

  
    // wife first big dick xvideos

    return (

      <>

        
       
        {sizefamily.map((row:any, index:any) => (
            
          <>

        <Divider style={{ marginTop: 25 }}/>
        <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 7 }}>Beneficiario {index+1}</Typography>
 
        <Grid container spacing={2} style={{ marginTop: 10 }} key={index}>


          <Grid item xs={3}>
              <AutocompleteField 
                options={parentesco_list}
                name={`${'parentesco_f'+index}`}
                label={'parentesco'}
                element={`${'parentesco_f'+index}`}
               
              />
          </Grid>


          <Grid item xs={3}>
              <AutocompleteField 
                options={type_documents_list}
                name={`${'type_document_f'+index}`}
                label={`Tipo documento`}
                element={`${'type_document_f'+index}`}
              />
          </Grid>

          <Grid item xs={3}>
            <InputNumeric 
              name={`${'num_document_f'+index}`}
              label={`Numero documento`}
              variant="outlined" 
              fullWidth
            />
          </Grid>

          <Grid item xs={3}>
            <InputField 
              name={`${'nombre_f'+index}`}
              label={`Nombre`}
              variant="outlined" 
              fullWidth
            />
          </Grid>


        </Grid>


        <Grid container spacing={2} style={{ marginTop: 10 }}>

          
          <Grid item xs={3}>
            <InputField 
              name={`${'apellido_f'+index}`}
              label={`apellido`}
              variant="outlined" 
              fullWidth
            />
          </Grid>


          <Grid item xs={3}>
              <AutocompleteField 
                  options={genderList}
                  name={`${'genero_f'+index}`}
                  label={`Genero`}
                  element={`${'genero_f'+index}`}
              />
          </Grid>
          
          <Grid item xs={3}>
              <DatePickerField label={`Fecha nacimiento`} 
                                      name={`${'fecha_nacimiento_f'+index}`}/>
          </Grid>


          <Grid item xs={3}>
              <AutocompleteField 
                  options={escolaridadList}
                  name={`${'escolaridad_f'+index}`}
                  label={`Escolaridad`}
                  element={`${'escolaridad_f'+index}`}
              />
          </Grid>
          

        </Grid>


        <Grid container spacing={2} style={{ marginTop: 10 }}>


            <Grid item xs={3}>
              <InputField 
                name={`${'ocupacion_f'+index}`}
                label={`ocupacion`}
                variant="outlined" 
                fullWidth
              />
            </Grid>

            <Grid item xs={3}>
                <UploadButtonField accept={'application/pdf'} 
                                  name={`${'documento_beneficiario_f'+index}`} 
                                  label={'Documento identidad'} 
                                  text={'Documento identidad'} 
                                  onChange={uploadDocument}/>

                {
                  formikProps.values.documento_beneficiario_f+index 
                       ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                         <LinearProgressWithLabel percentage={percentage_upload_cc} label={formikProps.values.documento_beneficiario_f+index .name} hasIcon={true} /> 
                        </Card>
                       :
                       ''
                }
            </Grid>

        </Grid>


      </>



        ))}
        
        </>
        
    )

}
